export default __webpack_public_path__ + "static/media/BrandonGrotesque-Bold.a05097ef.woff2";